import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/cloud-data',
        destPath: '',
      },
    ],
    'code._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/v1/connector',
        destPath: '/v1/connector',
      },
      {
        srcPath: '/_api/data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/v1/connector',
        destPath: '/v1/connector',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
    ],
    'cloud-data.wix-code.com': [
      {
        srcPath: '',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
      {
        srcPath: '/_api/data',
        destPath: '',
      },
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
      {
        srcPath: '/_api/data',
        destPath: '',
      },
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wix-data/v1/collections',
        destPath: '/v1/wix-data/collections',
      },
      {
        srcPath: '/wix-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/wix-data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/wix-data/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/wix-data/v1/bulk',
        destPath: '/v1/bulk',
      },
      {
        srcPath: '/wix-data/v1/external-databases',
        destPath: '/v1/external-databases',
      },
      {
        srcPath: '/wix-data/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/data/v2/bulk/items',
        destPath: '/v2/bulk/items',
      },
      {
        srcPath: '/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
    ],
    'www.wixgateway.com': [
      {
        srcPath: '/wix-data/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/wix-data/v1/bulk',
        destPath: '/v1/bulk',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_data-backend-public-sdk-poc_data';

/**
 * Adds an item to a collection.
 *
 * When an item is inserted into a collection, the following properties and values are added to it:
 * * `_id`: A unique identifier for an item in a collection. You can optionally provide your own ID when inserting the item. If you specify an ID that already exists in the collection, the insertion will fail.
 * * `_createdDate`: The date the item was added to the collection.
 * * `_updatedDate`: The date the item was last modified. When the item is first inserted, `_createdDate` and `_updatedDate` have the same value.
 * @deprecated Will be removed on 2025-06-01.
 */
export function insert(payload: object): RequestOptionsFactory<any> {
  function __insert({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.Insert',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __insert;
}

/**
 * Updates an item in a collection.
 *
 * An item ID must be submitted as part of the request, either as a path parameter or within the `item` body parameter. If an item is found in the specified collection with
 * the same ID, that item is updated. If the collection doesn't contain an item with that ID, the request fails.
 *
 * When an item is updated, its `_updatedDate` property is changed to the current date.
 *
 * **Note:**
 * After an item is updated, it only contains the properties included in the Update Data Item request. If the existing item has properties with values and those properties
 * aren't included in the updated item, their values are lost.
 * @deprecated Will be removed on 2025-06-01.
 */
export function update(payload: object): RequestOptionsFactory<any> {
  function __update({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'PUT' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.Update',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __update;
}

/**
 * Inserts or updates an item in a collection.
 *
 * The Save Data Item endpoint inserts or updates the specified item, depending on whether it already exists in the collection.
 *
 * * If you don't provide an ID, a new item is created.
 *
 * * If you provide an ID that doesn't exist in the collection, a new item is created with that ID.
 *
 * * If an item with the ID you provide already exists in the collection, that item is updated. When an item is updated, its `_updatedDate` property is changed to the current date.
 *
 * ***Note:*** When you provide an item with an ID that already exists in the collection, the item you provide completely replaces the existing item with that ID.
 * This means that all of the item's previous properties and values are lost.
 * @deprecated Will be removed on 2025-06-01.
 */
export function save(payload: object): RequestOptionsFactory<any> {
  function __save({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.cloud.data.api.dataservice.WixDataService.Save',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/save',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __save;
}

/**
 * Retrieves an item from a collection.
 * @deprecated Will be removed on 2025-06-01.
 */
export function get(payload: object): RequestOptionsFactory<any> {
  function __get({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.cloud.data.api.dataservice.WixDataService.Get',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload, true),
    };

    return metadata;
  }

  return __get;
}

/**
 * Removes an item from a collection.
 *
 * If any items in other collections reference the removed item in a reference or multi-reference field, the field is cleared.
 *
 * **Note:**
 * Once an item has been removed from a collection, it can't be restored.
 * @deprecated Will be removed on 2025-06-01.
 */
export function remove(payload: object): RequestOptionsFactory<any> {
  function __remove({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.Remove',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __remove;
}

/**
 * Removes all items from a collection. Site owner (`ADMIN`) permissions are required in order to invoke this operation.
 *
 * If any items in other collections reference the removed items in reference or multi-reference fields, those fields are cleared.
 *
 * **Note:**
 * Once items have been removed from a collection, they can't be restored.
 * @deprecated Will be removed on 2025-06-01.
 */
export function truncate(payload: object): RequestOptionsFactory<any> {
  function __truncate({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.Truncate',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/truncate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __truncate;
}

/**
 * Retrieves a list of items, on the basis of the filtering, sorting, and paging preferences you provide.
 *
 * For more details on using queries, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * @deprecated Will be removed on 2025-06-01.
 */
export function query(payload: object): RequestOptionsFactory<any> {
  function __query({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.cloud.data.api.dataservice.WixDataService.Query',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/query',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload, true),

      fallback: [
        {
          method: 'POST' as any,
          url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
            protoPath: '/v1/items/query',
            data: payload,
            host,
          }),
          data: payload,
        },
      ],
    };

    return metadata;
  }

  return __query;
}

/** @deprecated Will be removed on 2025-06-01. */
export function aggregate(payload: object): RequestOptionsFactory<any> {
  function __aggregate({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.Aggregate',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/aggregate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __aggregate;
}

/**
 * Returns the number of items in a collection that match a query.
 * @deprecated Will be removed on 2025-06-01.
 */
export function count(payload: object): RequestOptionsFactory<any> {
  function __count({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.cloud.data.api.dataservice.WixDataService.Count',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/count',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __count;
}

/**
 * Retrieves a list of distinct values for a given property in all items that match a query, without duplicates.
 *
 * As with the [Query Data Items]() endpoint, this endpoint retrieves items based on the filtering, sorting, and paging preferences you provide.
 * However, the Query Distinct Values endpoint doesn't return all of the full items that match the query.
 * Rather, it returns all unique values of the property you specify in `propertyName` for items that match the query.
 * If more than one item has the same value for that property, that value appears only once.
 *
 * For more details on using queries, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * @deprecated Will be removed on 2025-06-01.
 */
export function distinct(payload: object): RequestOptionsFactory<any> {
  function __distinct({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.Distinct',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/distinct',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __distinct;
}

/**
 * Adds multiple items to a collection.
 *
 * When each item is inserted into a collection, the following properties and values are added to it:
 * * `_id`: A unique identifier for an item in a collection. You can optionally provide your own ID when inserting the item. If you specify an ID that already exists in the collection, the insertion will fail.
 * * `_createdDate`: The date the item was added to the collection.
 * * `_updatedDate`: The date the item was last modified. When the item is first inserted, `_createdDate` and `_updatedDate` have the same value.
 *
 * The endpoint returns a list of the IDs of items successfully inserted in `insertedItemIds`.
 * When any items can't be inserted, error details are provided for each failed item in `errors`.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkInsert(payload: object): RequestOptionsFactory<any> {
  function __bulkInsert({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkInsert',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/items/insert',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkInsert;
}

/**
 * Inserts or updates multiple items in a collection.
 *
 * The Bulk Save Data Items endpoint inserts or updates each item, depending on whether it already exists in the collection. For each item:
 *
 * * If you don't provide an ID, a new item is created.
 *
 * * If you provide an ID that doesn't exist in the collection, a new item is created with that ID.
 *
 * * If an item with the ID you provide already exists in the collection, that item is updated. When an item is updated, its `_updatedDate` property is changed to the current date.
 *
 * The endpoint returns a list of the IDs of items successfully inserted in `insertedItemIds` and a list of the IDs of items successfully updated in `updatedItemIds`.
 * When any items can't be inserted or updated, error details are provided for each failed item in `errors`.
 *
 * ***Note:*** When you provide an item with an ID that already exists in the collection, the item you provide completely replaces the existing item with that ID.
 * This means that all of the item's previous properties and values are lost.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkSave(payload: object): RequestOptionsFactory<any> {
  function __bulkSave({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkSave',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/items/save',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkSave;
}

/**
 * Updates multiple items in a collection.
 *
 * Each item in the request must include an ID. If an item is found in the specified collection with
 * the same ID, that item is updated. If the collection doesn't contain an item with that ID, the update fails.
 *
 * When an item is updated, its `_updatedDate` property is changed to the current date.
 *
 * The endpoint returns a list of the IDs of items successfully updated in `updatedItemIds`.
 * When any items can't be inserted, error details are provided for each failed item in `errors`.
 *
 * **Note:**
 * After each item is updated, it only contains the properties included in the Update Data Item request. If the existing item has properties with values and those properties
 * aren't included in the updated item, their values are lost.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkUpdate(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdate({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkUpdate',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/items/update',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdate;
}

/**
 * Removes multiple items from a collection.
 *
 * If any items in other collections reference the removed items in reference or multi-reference fields, the fields are cleared.
 *
 * The endpoint returns a list of the IDs of items successfully removed in `removedItemIds`.
 * When any items can't be removed, error details are provided for each failed item in `errors`.
 *
 * **Note:** Once an item has been removed from a collection, it can't be restored.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkRemove(payload: object): RequestOptionsFactory<any> {
  function __bulkRemove({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkRemove',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/items/remove',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkRemove;
}

/**
 * Gets the full items referenced in the specified property of an item.
 *
 * For example, suppose you have a **Movies** collection with an **Actors** field that contains references to items in a **People** collection.
 * Querying the **Movies** collection using the Query Referenced Data Items endpoint returns the relevant **People** items referenced in the **Actors** field of the specified **Movie** item.
 * This gives you information from the **People** collection about each of the actors in the specified movie.
 * @deprecated Will be removed on 2025-06-01.
 */
export function queryReferenced(payload: object): RequestOptionsFactory<any> {
  function __queryReferenced({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.QueryReferenced',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/query-referenced',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __queryReferenced;
}

/**
 * Inserts one or more references in the specified properties of items in a collection.
 *
 * The Bulk Insert References endpoint adds one or more references to a collection.
 * Each new reference in the `references` field specifies a referring item's ID, the property in which to insert the reference, and the ID of the referenced item.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkInsertReferences(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkInsertReferences({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkInsertReferences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/references/insert',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkInsertReferences;
}

/**
 * Replaces references in a specified property of a specified data item.
 *
 * The Bulk Replace References endpoint replaces the existing reference or references contained in the property specified in `propertyName` within the data item specified in `referringItemId`.
 * The endpoint removes existing references and in their place it adds references to the items specified in `newReferencedItemIds`.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkReplaceReferences(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkReplaceReferences({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkReplaceReferences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/references/replace',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkReplaceReferences;
}

/**
 * Removes one or more references.
 * @deprecated Will be removed on 2025-06-01.
 */
export function bulkRemoveReferences(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkRemoveReferences({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.BulkRemoveReferences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/bulk/references/remove',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkRemoveReferences;
}

/**
 * Checks if a specific property of a referring item contains a reference to another specific item.
 * @deprecated Will be removed on 2025-06-01.
 */
export function isReferenced(payload: object): RequestOptionsFactory<any> {
  function __isReferenced({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v1.data_service',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.dataservice.WixDataService.IsReferenced',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiDataserviceWixDataServiceUrl({
        protoPath: '/v1/items/is-referenced',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __isReferenced;
}
